// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contentsWrapper":"styles__contentsWrapper___16-UG","inlineMenuWrapper":"styles__inlineMenuWrapper___3KmHD"};
    if(module.hot) {
      // 1778083493171
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  